<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogDetail" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Detail de la demande</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                     <v-layout row >
                    <v-flex xs12  class="text-xs-right" >
                        <v-btn icons dark color="orange" @click="imprimerDetail()">Imprimer<v-icon right>print</v-icon></v-btn>
                    </v-flex>
                </v-layout>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card color="" class="mb-5" flat >
                                    <v-layout wrap>
                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations generales sur la demande
                                            </v-alert>
                                            <v-card flat>
                                                <v-layout wrap>
                                                    <v-card-text>
                                                        <v-flex xs12>
                                                            <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                                <v-layout row>
                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Identifiant de la demande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.ref}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <v-layout row>
                                                                            <v-flex xs6>Zone</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.libZone}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Batiment</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.batiment}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Salle</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.salle}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Priorite</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                   {{demandeDetail.libPriorite}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>



                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de la demande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.date}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Date d'enregistrement</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.dateCreated}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Nom du demandeur</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                               {{demandeDetail.nomDemandeur}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <!-- <v-layout row>
                                                                            <v-flex xs6>Note du representant de zone</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.note}} / 10
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider> -->

                                                                           
                                                                        <v-layout row>
                                                                            <v-flex  v-if="demandeDetail.imageDmd1" xs3 class="mr-3">
                                                                                <a :href="demandeDetail.imageDmd1"  target=_blank>
                                                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src='demandeDetail.imageDmd1' > </v-avatar>
                                                                                </a>
                                                                            </v-flex>

                                                                            <!-- <v-flex  v-if="demandeDetail.imageDmd2" xs3 class="mr-3">
                                                                                <a :href="demandeDetail.imageDmd2"  target=_blank>
                                                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageDmd2" alt="avatar"></v-avatar>
                                                                                </a>
                                                                            </v-flex>

                                                                             <v-flex  v-if="demandeDetail.imageDmd3" xs3 class="mr-3">
                                                                                <a :href="demandeDetail.imageDmd3"  target=_blank>
                                                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageDmd3" alt="avatar"></v-avatar>
                                                                                </a>
                                                                            </v-flex> -->
                                                                        </v-layout>
                                                                      
                                                                        

                                                                
                                                                    </v-flex>

                                                                    <v-flex xs6 class="text-xs-left"> <!--BAS-->
                                                                              

                                                                        <v-layout row>
                                                                            <v-flex xs6>Status</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.libStatut}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row v-if="!droitAcces.new_maintenance" >
                                                                            <v-flex xs6>Etat</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.libEtatDmd}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider  v-if="!droitAcces.new_maintenance" class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Enregistré par </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                 {{demandeDetail.userCreate}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <v-layout row>
                                                                            <v-flex xs6>Domaine d'activité </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                 {{demandeDetail.domaine}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <v-layout row>
                                                                            <v-flex xs6>Note </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                 {{demandeDetail.note}} / 10
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                          <v-layout row>
                                                                               <v-flex xs2>Description </v-flex>
                                                                               <v-flex xs10>
                                                                                    <el-form    class="demo-ruleForm">
                                                                                        <el-form-item   label="" style="width:100%" >
                                                                                            <el-input  disabled  type="textarea" v-model="demandeDetail.commentaire"></el-input>
                                                                                        </el-form-item>
                                                                                    </el-form >
                                                                                </v-flex>
                                                                             
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row>
                                                                               <v-flex xs2>Pourquoi cette note </v-flex>
                                                                               <v-flex xs10>
                                                                                    <el-form    class="demo-ruleForm">
                                                                                        <el-form-item label="" style="width:100%" >
                                                                                            <el-input  disabled :rows="6"  type="textarea" v-model="demandeDetail.remarqueNote"></el-input>
                                                                                        </el-form-item>
                                                                                    </el-form >
                                                                                </v-flex>
                                                                        </v-layout>
                                                                        
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-flex>
                                                    </v-card-text>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12 v-if="(user.type == 1 || user.type == 4 || user.type == 5)   && demandeDetail.etatDmd > 2   "  >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Visites et constats
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                     <v-layout row>
                                                        <v-flex xs3>Constat enregistré par le responsable:</v-flex>
                                                        <v-flex xs6 class="text-xs-left title">
                                                            {{demandeDetail.superviseur}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>

                                                     <v-layout row>
                                                        <v-flex xs3>Date et heure du constat:</v-flex>
                                                        <v-flex xs6 class="text-xs-left title">
                                                            {{demandeDetail.dateConstat}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>
                                                    <el-form disabled id="formRapport" style="width:100%"   :model="formRapport"  >
                            <v-layout row >
                                <v-flex xs6 >
                                   <v-layout row>
                                        <v-flex v-if="demandeDetail.imageConst1" xs3 class="mr-3">
                                            <a :href="demandeDetail.imageConst1"  target=_blank>
                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageConst1" ></v-avatar>
                                            </a>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                 <v-flex xs6 >
                                         <el-form-item style="width:100%" label="Rapport de constat" >
                                        <el-input
                                        style="width:100%"
                                           disabled
                                            type="textarea"
                                            :rows="6"
                                            placeholder="Rapport sur le constat"
                                            v-model="formRapport.rapport">
                                        </el-input>
                                         </el-form-item >
                                   
                                </v-flex>
                            </v-layout>
                            </el-form>
                       


                                                    <v-layout wrap>
                                                        <v-flex xs12>
                                                            <v-card>
                                                                
                                                                 <!-- <v-flex xs12 v-if="user.type == 1 || user.type == 4 "   >
                                                                    <v-chip style="font-size:20px" label outline color="green"><b>Total (TTC): {{totalTTC}} fcfa</b></v-chip>
                                                                </v-flex> -->

                                                                       
                                            
            
                                            <v-layout row>
                                                <el-table :data="tableProduit" style="width: 100%">
                                                    <el-table-column prop="designation" label="Designation" sortable> </el-table-column>
                                                    <el-table-column prop="quantite" label="Quantite"> </el-table-column>
                                                    
                                                    <!-- <el-table-column v-if="user.type == 1 || user.type == 4 " prop="prixU" label="Prix unitaire"></el-table-column>
                                                    <el-table-column v-if="user.type == 1 || user.type == 4 " prop="mntTotal" label="Total"></el-table-column> -->
                                                </el-table>
                                            </v-layout>
                                            <br>
                                        </v-card>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                         <v-flex xs12 v-if="demandeDetail.etatDmd >= 3">
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Validation du devis
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                           <v-layout row>
                                                                <el-table :data="demandeDetail.nomValidateurs" style="width: 100%">
                                                                    <el-table-column prop="nom" label="Nom du validateur" sortable> </el-table-column>
                                                                    <el-table-column prop="date" label="Date"> </el-table-column>
                                                                    <el-table-column prop="valider" label="Decision"></el-table-column>
                                                                </el-table>
                                                            </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12 v-if="demandeDetail.etatDmd >= 7">
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Planification de l'intervention
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>
                                                          <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Date debut planifier pour  l'intervention </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.dateDbt}} à {{demandeDetail.hrDbt}} 
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                         

                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de fin de l'intervention</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.dateFin}} à {{demandeDetail.hrFin}} 
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                    </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                         <v-flex xs12 v-if="droitAcces.new_maintenance && demandeDetail.etatDmd >= 8">
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Rapport de maintenance
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>
                                                          <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                <v-layout row>
                                                                    <v-flex xs6>Effectué par  le technicien</v-flex>
                                                                    <v-flex class="title" xs6>{{demandeDetail.nomTech}} </v-flex>
                                                                </v-layout>
                                                                 <v-layout row>
                                                                    <v-flex xs6>Date du rapport</v-flex>
                                                                    <v-flex class="title" xs6>{{demandeDetail.dateDepannage}} </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>
                                                                <v-layout row>
                                                                     <v-flex xs8 >
                                                                        
                                                                    <v-layout row>
                                                                        <v-flex v-if="demandeDetail.imageDepan1" xs3 class="mr-3">
                                                                            <a :href="demandeDetail.imageDepan1"  target=_blank>
                                                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageDepan1" ></v-avatar>
                                                                            </a>
                                                                        </v-flex>
                                                                    </v-layout>
                               
                                                                    </v-flex>
                                                                </v-layout>
                                                              
                                                            </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                        </v-flex>
                    </v-layout>
                    
                </v-card-text>
                
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "DetailMaintenance",
        props:["show","demandeDetail"],
        data() 
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit:[],
            totalTTC:0,
            formRapport:{},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
          
 

         }    
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){
                   this.loadDevisConstat()
               }
            }
        },

        methods: {
            closeDialog(){
                this.$emit('close')
            },
             loadDevisConstat ()
            {
            this.loading = true
            let url = this.domaine + 'demande_maintenance/devis/constat/'+this.demandeDetail.idDemande
            this.$http.get(url).then(response => {
             
                this.tableProduit = response.body.tableProduit
                this.formRapport.rapport = response.body.rapport
                this.totalTTC = response.body.total
                 this.loading = false
            },errResp=>{
                 this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
            })
            },
             handleRemove(file, fileList) {
            },
            handleSuccess(response, file, fileList){
                    this.fileList.push(file)

            },
            handlePictureCardPreview(file, fileList) {
                this.dialogImageUrl = file.url;
               
                this.dialogVisible = true;
            },
            imprimerDetail(){
               

                let  url = this.domaine+"demande_maintenance/imprimerPDF/demande/"+this.user.id+"/"+this.demandeDetail.idDemande 
                window.open(url)
            }
        },
        mounted(){
            
        }

    }
    </script>


// WEBPACK FOOTER //
// src/components/maintenance/DetailMaintenance.vue